import { createContext, useContext } from "react";
import { PermissionChecker } from "../../types/permission";
 
export interface PermissionContextType {
  hasPermission: PermissionChecker;
}
 
export const PermissionContext = createContext<PermissionContextType | null>(null);


export const usePermission = (): PermissionContextType => {
  const context = useContext(PermissionContext);

  if (!context) {
    return {
      hasPermission: () => true,
      // throw new Error("usePermission must be used within PermissionProvider");
    };
  }
  return context;
};